// extracted by mini-css-extract-plugin
module.exports = {"optionInput":"Forms_optionInput__rnsCd","form":"Forms_form__u2kmt","textfield":"Forms_textfield__1oAte","errortext":"Forms_errortext__1rvHb"};